import { Option } from '@common-fe/common-fe';

import { storeCreator } from '@/utils/store/store.utils';

export interface BreadcrumbsOption<T> extends Option<T> {
  mobileTitle?: string;
  isMobileSubtitleButton?: boolean;
  isMobileMode?: boolean;
}
interface State {
  breadcrumbs: BreadcrumbsOption<string>[];
  backBtn: boolean;
  backBtnTitle: string | undefined;
  setBreadcrumbs: (value: BreadcrumbsOption<string>[]) => void;
  handleSetBackBtn: (value: boolean) => void;
  setBackBtnTitle: (value: string) => void;
  resetBackBtnTitle: () => void;
}

export const useStore = storeCreator<State>((set) => ({
  breadcrumbs: [],
  backBtn: false,
  backBtnTitle: undefined,
  handleSetBackBtn: (value: boolean) =>
    set({
      backBtn: value,
    }),
  setBreadcrumbs: (value: Option<string>[]) =>
    set(() => ({
      breadcrumbs: value,
    })),
  setBackBtnTitle: (value: string) =>
    set({
      backBtnTitle: value,
    }),
  resetBackBtnTitle: () =>
    set({
      backBtnTitle: undefined,
    }),
}));

export const useBreadcrumbsStore = () => {
  const { breadcrumbs, backBtn, backBtnTitle, setBreadcrumbs, handleSetBackBtn, setBackBtnTitle, resetBackBtnTitle, ...store } = useStore();
  return {
    ...store,
    breadcrumbs,
    backBtn,
    backBtnTitle,
    setBreadcrumbs,
    handleSetBackBtn,
    setBackBtnTitle,
    resetBackBtnTitle,
  };
};
